export default {"src":"/_next/static/media/zw.c65f4dfa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};